import { createFileRoute } from '@tanstack/react-router'
import { CloudUploadIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data')({
  staticData: {
    title: 'route.coreUploadData',
    crumb: 'route.coreUploadData',
    icon: CloudUploadIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
